import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTheme } from 'styled-components';

import adminApi from '../../../APIs/admin';
import UserInformation from '../../../components/PrinterBrowsedClientDetails/UserInformation';
import UserProfile from '../../../components/UserDetails/UserProfile';
import { Divider, NavigateBack, Typography } from '../../../designComponents';
import { RootState } from '../../../store/selectors';
import { requestAPI } from '../../../utils';
import { ViewJobContainerStyled } from '../../BrowseJobs/BrowseJobDetails/style';

const TechnicianDetail = () => {
  const theme = useTheme();
  const singleTechnician = useSelector(
    (state: RootState) => state.singleClientData,
  );
  const { technicianId } = useParams();

  const getSingleTechnician = async () => {
    try {
      if (typeof technicianId !== 'undefined') {
        await requestAPI(adminApi.getSingleUser(technicianId));
      }
    } catch (error: any) {
      console.error(error);
    }
  };

  useEffect(() => {
    getSingleTechnician();
  }, []);

  return (
    <ViewJobContainerStyled>
      <div
        style={{
          position: 'sticky',
          top: '60px',
          zIndex: '999',
          paddingTop: '5px',
          background: '#fff',
        }}
      >
        <NavigateBack />
      </div>
      <div className="contents">
        <Typography
          variant="heading"
          strong
          style={{ color: theme.colors.blueFade }}
        >
          Technician Details{' '}
        </Typography>
        <Divider spaceY="20px" />

        <UserProfile
          name={singleTechnician?.fullName}
          email={singleTechnician?.emailAddress}
          position={singleTechnician?.role || 'Fire Team'}
        />
        <Divider spaceY="20px" />

        <UserInformation
          userName={singleTechnician?.fullName || ''}
          userType={singleTechnician?.role || ''}
          userEmail={singleTechnician?.emailAddress || ''}
          userAddress={
            singleTechnician?.contactInfo?.address1.concat(
              ', ',
              singleTechnician?.contactInfo?.city,
            ) ?? 'Tinkune, Kathmandu'
          }
          contactNumber={singleTechnician?.mobileNumber || ''}
        />
      </div>
    </ViewJobContainerStyled>
  );
};

export default TechnicianDetail;
